import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import Align from '@marvelapp/marvel-ui/align';
import Input from '@marvelapp/marvel-ui/input';
import InputLabel from '@marvelapp/marvel-ui/input-label';
import MarvelLink from '@marvelapp/marvel-ui/link';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Popover from '@marvelapp/marvel-ui/popover';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Position from '@marvelapp/marvel-ui/position';

import styles from './style/general.module.css';

class FormInput extends Component {
  constructor(props) {
    super(props);
    this.textInput = null;
  }

  componentDidMount() {
    this.focusTextInput();
  }

  focusTextInput() {
    if (this.textInput) this.textInput.focus();
  }

  setTextInputRef = element => {
    this.textInput = element;
  };

  render() {
    const {
      errorMessage,
      focusOnRender,
      helpLink,
      isInputInvalid,
      label,
      name,
      onChange,
      placeholder,
      shouldShowTick,
      shouldShowValidationError,
      type,
      tabIndex,
      isSSOSignIn,
    } = this.props;
    return (
      <div>
        <Spacing type="margin" size="xxs" position="bottom">
          <Position type="relative">
            <InputLabel fontWeight="regular" htmlFor={name}>
              {label}
            </InputLabel>
            {helpLink && (
              <Position type="absolute" location="topRight">
                <Align type="right">
                  <Paragraph size="m" color="steel">
                    <Link to={helpLink} tabIndex={8}>
                      <MarvelLink type="blue">Forgot password?</MarvelLink>
                    </Link>
                  </Paragraph>
                </Align>
              </Position>
            )}
          </Position>
        </Spacing>
        <Position type="relative">
          <Popover
            align="right"
            alignContent="right"
            fullWidth
            isActive={shouldShowValidationError}
            maxWidth={300}
            position="top"
            size="small"
            type="error"
          >
            <div className={styles.popover}>{errorMessage}</div>
          </Popover>

          <Input
            fullWidth
            hasError={isInputInvalid}
            id={name}
            name={name}
            onChange={onChange}
            placeholder={placeholder}
            showTick={shouldShowTick}
            size="large"
            type={type}
            tabIndex={tabIndex + 1}
            withRef={focusOnRender ? this.setTextInputRef : null}
          />
          {isSSOSignIn && (
            <Position type="absolute" location="topRight">
              <Spacing type="margin" size="s">
                <Heading size="m" weight="semibold">
                  .marvelapp.com
                </Heading>
              </Spacing>
            </Position>
          )}
        </Position>
      </div>
    );
  }
}

FormInput.propTypes = {
  errorMessage: PropTypes.string,
  focusOnRender: PropTypes.bool,
  helpLink: PropTypes.string,
  isInputInvalid: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  shouldShowTick: PropTypes.bool,
  isSSOSignIn: PropTypes.bool,
  shouldShowValidationError: PropTypes.bool,
  tabIndex: PropTypes.num,
  type: PropTypes.string,
};

FormInput.defaultProps = {
  focusOnRender: false,
  isInputInvalid: false,
  shouldShowTick: false,
  shouldShowValidationError: false,
};

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/modules/FormWrap/FormInput/index.js